import { LOCALIZED_IMAGES } from "../../../i18n/localizedImages";
import { resolveLocalizedImageSrc } from "../../../utils/resolveLocalizedImage";

/** Shared brand tokens for marketing landing (light page theme) */
export const BRAND = {
  teal: "#1DB8A0",
  tealDark: "#0F7B6B",
  tealLight: "#E6FAF6",
  tealGlow: "rgba(29, 184, 160, 0.14)",

  /** Headings & primary text on light backgrounds */
  navy: "#0A1628",
  navyMid: "#1E293B",

  /** Dark UI surfaces (dashboard embed mockup, teal CTA band) */
  navyDark: "#0E1F3D",
  navyDarkMid: "#132842",

  pageBg: "#FFFFFF",
  sectionBg: "#FFFFFF",
  sectionBgMuted: "#F8FAFC",
  sectionBgTint: "#F4F9F8",
  bgLight: "#F4F9F8",

  textMuted: "rgba(10, 22, 40, 0.68)",
  textSoft: "rgba(10, 22, 40, 0.48)",
  textSecondary: "#4A5568",

  textOnDark: "#FFFFFF",
  textMutedOnDark: "rgba(255, 255, 255, 0.72)",
  textSoftOnDark: "rgba(255, 255, 255, 0.55)",

  border: "rgba(10, 22, 40, 0.1)",
  borderLight: "#E2E8F0",
  borderOnDark: "rgba(255, 255, 255, 0.1)",

  gradientHero:
    "radial-gradient(ellipse 80% 60% at 50% -10%, rgba(29, 184, 160, 0.12) 0%, transparent 55%), linear-gradient(180deg, #ffffff 0%, #f8fafc 58%, #ffffff 100%)",

  gradientSectionMuted: "linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 100%)",
  gradientTealCta:
    "linear-gradient(135deg, #0F7B6B 0%, #1DB8A0 45%, #1a9a86 100%)",
};

/** Logo — PNG primary (navbar/footer), SVG fallback */
export const LOGO_SRC = "/assets/PatientMeshLogo.png";
export const LOGO_SRC_SVG = "/assets/PatientMeshLogo.svg";
/** @deprecated alias */
export const LOGO_SRC_PNG = LOGO_SRC;

/** @deprecated Use LOCALIZED_IMAGES / LocalizedImage — kept for transitional imports */
export const MARKETING_HERO_DEVICE_MOCKUPS = LOCALIZED_IMAGES["hero-device-mockup"];
/** @deprecated Use LOCALIZED_IMAGES / LocalizedImage */
export const MARKETING_DATA_TABLET_MOCKUPS = LOCALIZED_IMAGES["hero-data-tablet"];
/** @deprecated Use LOCALIZED_IMAGES / LocalizedImage */
export const MARKETING_AI_LLM_DASHBOARDS = LOCALIZED_IMAGES["hero-ai-llm-dashboard"];

/** Mobil uygulama mockup (language-neutral path; prefer imageKey `app-mockup`) */
export const MARKETING_APP_MOCKUP = LOCALIZED_IMAGES["app-mockup"].tr;

/** Testimonial / showcase görselleri */
export const MARKETING_SHOWCASE = {
  llm: LOCALIZED_IMAGES["showcase-llm"].tr,
  cloud: LOCALIZED_IMAGES["showcase-cloud"].tr,
  aiPlatform: LOCALIZED_IMAGES["showcase-ai-platform"].tr,
};

/** Data integration animasyonu */
export const MARKETING_INTEGRATION_VIDEO = "/assets/marketing/marketing-cizim-video.mp4";

/** Geo redundancy / altyapı güvenlik görseli */
export const MARKETING_CLOUD_SECURITY = LOCALIZED_IMAGES["cloud-security"].tr;

/** @deprecated Prefer useLocalizedImageSrc("hero-ai-llm-dashboard") */
export function getMarketingAiLlmDashboard(language) {
  return resolveLocalizedImageSrc("hero-ai-llm-dashboard", language);
}

/** @deprecated Prefer useLocalizedImageSrc("hero-data-tablet") */
export function getMarketingDataTabletMockup(language) {
  return resolveLocalizedImageSrc("hero-data-tablet", language);
}

/** @deprecated Prefer useLocalizedImageSrc("hero-device-mockup") */
export function getMarketingHeroDeviceMockup(language) {
  return resolveLocalizedImageSrc("hero-device-mockup", language);
}

/** Marketing sections: consistent padding & overflow-safe containers */
export const MARKETING_SECTION_SX = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  overflowX: "hidden",
};

/** Yan boşluklar — içerik kenarlara yapışmasın */
export const MARKETING_GUTTER_PX = {
  xs: 2.5,
  sm: 3.5,
  md: 4.5,
  lg: 5.5,
  xl: 7,
};

/** İçerik şeridi maksimum genişlik (px); dışında doğal yan boşluk kalır */
export const MARKETING_CONTENT_MAX_WIDTH = 1280;

export const MARKETING_CONTAINER_SX = {
  position: "relative",
  zIndex: 1,
  width: "100%",
  maxWidth: `${MARKETING_CONTENT_MAX_WIDTH}px`,
  mx: "auto",
  minWidth: 0,
  px: MARKETING_GUTTER_PX,
  boxSizing: "border-box",
};

/** Tüm marketing bölümleri aynı içerik genişliğinde (StatsSection ile hizalı) */
export const MARKETING_CONTAINER_WIDE_SX = MARKETING_CONTAINER_SX;
